<!--
  mall/src/views/user-center/help/help.vue
  /web/user-center-help
-->

<template>
  <div style="background-color: #E5E5E5">
    <div class="cate-list van-hairline--top">
      <div v-for="c in cateList" :key="c" class="cate-tag-btn">
        <div v-if="c === cateName">
          <van-tag round size="large" type="primary" @click="reloadHelp(c)">{{ c }}</van-tag>
        </div>
        <div v-else>
          <van-tag plain round size="large" type="primary" @click="reloadHelp(c)">{{ c }}</van-tag>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="help in helpList" :key="help.helpId" :name="help.helpId">
        <template #title>
          <van-icon color="#999" name="question-o" />
          {{ help.title }}
        </template>
        <div style="line-height: 22px;font-size: 12px;padding: 8px" v-html="help.content"></div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getHelpList } from "@/api/sys-api";

export default {
  name: "help",

  data() {
    return {
      activeNames: ['1'],
      helpList: [],
      cateList: [],
      cateName: ''
    }
  },

  created() {
    budo_log.info("#48 help created")

    getHelpList().then(res => {
      this.helpList = res.data;
      this.cateList = new Set(res.data.map(h => h.cate));
      budo_log.info("#46 created cateList", this.cateList)
    })
  },

  methods: {
    reloadHelp(cateName) {
      getHelpList(cateName).then(res => {
        this.helpList = res.data;
        this.cateName = cateName;
      })
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    }
  }
}
</script>

<style lang="scss" scoped>
.cate-list {
  background-color: #fff;
  margin-bottom: 8px;
  display: flex;
}

.cate-tag-btn {
  margin: 8px 2px;
}
</style>
